// extracted by mini-css-extract-plugin
export default {"FormContainer":"styles_FormContainer__c8t48"};